module.exports = __webpack_public_path__ + "img/ic-payment-success-2.31c68b54.svg";